module.exports = __webpack_public_path__ + "img/pup.df61e3f0.png";